<app-side-menu>
  <div class="parf-wrap">
    <div class="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-3">
      <div>
        <h1 class="parf-title">
          <i class="fas fa-plus-circle me-2"></i>
          {{ mode === 'view' ? 'Visualizar faixa de aprovação' : (mode === 'edit' ? 'Editar faixa de aprovação' : 'Nova faixa de aprovação') }}
        </h1>
        <p class="text-muted small mb-0">POST em price-approval-ranges centralizado na área de Price Approval.</p>
      </div>
      <button type="button" class="btn btn-outline-secondary" (click)="cancel()">
        <i class="fas fa-arrow-left me-1"></i>
        Voltar
      </button>
    </div>

    <form [formGroup]="form" (ngSubmit)="submit()" class="card border-0 shadow-sm">
      <div class="card-body">
        <div *ngIf="loadingRange" class="alert alert-info py-2">
          <span class="spinner-border spinner-border-sm me-2"></span>
          Carregando faixa...
        </div>
        <h5 class="card-title text-primary mb-3">Regra e valores</h5>
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label">Nome da regra <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="ruleName" placeholder="Ex.: Faixa 10k-50k" />
          </div>
          <div class="col-md-3">
            <label class="form-label">Valor mínimo (R$) <span class="text-danger">*</span></label>
            <input type="number" class="form-control" formControlName="minAmount" min="0" step="0.01" />
          </div>
          <div class="col-md-3">
            <label class="form-label">Valor máximo (R$) <span class="text-danger">*</span></label>
            <input type="number" class="form-control" formControlName="maxAmount" min="0" step="0.01" />
          </div>
          <div class="col-12">
            <label class="form-label">Descrição</label>
            <textarea class="form-control" rows="2" formControlName="description" placeholder="Opcional"></textarea>
          </div>
        </div>

        <hr class="my-4" />
        <h5 class="text-primary mb-3">Comportamento</h5>
        <div class="row g-3">
          <div class="col-md-6 col-lg-4">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="mgr" formControlName="requiresManagerApproval" />
              <label class="form-check-label" for="mgr">Exige aprovação do gestor</label>
            </div>
          </div>
          <div class="col-md-6 col-lg-4">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="skip" formControlName="skipApprovalWhenInRange" />
              <label class="form-check-label" for="skip">Pular aprovação quando na faixa</label>
            </div>
          </div>
          <div class="col-md-6 col-lg-4">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="seq" formControlName="requiresSequentialApproval" />
              <label class="form-check-label" for="seq">Aprovação sequencial</label>
            </div>
          </div>
          <div class="col-md-6 col-lg-4">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="act" formControlName="isActive" />
              <label class="form-check-label" for="act">Regra ativa</label>
            </div>
          </div>
        </div>

        <hr class="my-4" />
        <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
          <h5 class="text-primary mb-0">Aprovadores adicionais</h5>
          <button
            type="button"
            class="btn btn-sm btn-outline-primary"
            (click)="addApprover()"
            [disabled]="approvers.length >= 5">
            <i class="fas fa-plus me-1"></i>
            Adicionar
          </button>
        </div>
        <p class="small text-muted">
          O campo <strong>requiredAdditionalApprovalsCount</strong> será calculado a partir das linhas informadas
          (limite de <strong>5 níveis</strong> de aprovação).
        </p>

        <div *ngIf="loadingStaff" class="text-muted small mb-2">
          <span class="spinner-border spinner-border-sm me-1"></span>
          Carregando colaboradores...
        </div>

        <div formArrayName="additionalApprovers" class="d-flex flex-column gap-3">
          <div class="border rounded p-3 bg-light" *ngFor="let grp of approvers.controls; let i = index" [formGroupName]="i">
            <div class="row g-2 align-items-end">
              <div class="col-md-3">
                <label class="form-label small">Nível</label>
                <input type="text" class="form-control form-control-sm" formControlName="approvalLevel" />
              </div>
              <div class="col-md-7">
                <label class="form-label small">Colaborador <span class="text-danger">*</span></label>
                <select class="form-select form-select-sm" formControlName="staffId">
                  <option [ngValue]="null">Selecione...</option>
                  <option *ngFor="let s of staffMembers" [ngValue]="s.Id">{{ s.FullName }} (#{{ s.Id }})</option>
                </select>
              </div>
              <div class="col-md-2 text-end">
                <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeApprover(i)" [disabled]="approvers.length <= 1">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end gap-2 mt-4">
          <button type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancelar</button>
          <button type="submit" class="btn btn-primary" *ngIf="mode !== 'view'" [disabled]="isSaving">
            <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-1"></span>
            Salvar faixa
          </button>
        </div>
      </div>
    </form>
  </div>
</app-side-menu>
